import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import {
  BrowserView,
  MobileView
} from "react-device-detect";

import videoMP4 from '../assets/bg-d.mp4';
import videoWEBm from '../assets/bg-d.webm';
import bg from '../assets/bg.gif';





class Notfound extends Component {

  state = {
    loading: true
  };

  componentDidMount() {
    document.body.classList.remove('hide');
    setTimeout(() => this.setState({ loading: false }), 500); // simulates loading of data
  }

  
  render() {

    document.body.classList.add('hide');

    const { loading } = this.state;

    if(loading) { 
        return null; 
      }

    return (
    

      <div>
       
       <div className="w-full h-screen bg-black text-white flex items-center">
       
        <div className="pl-8 md:pl-16 xl:pl-64 relative z-40">
          <Fade>
            <p className="text-white font-heading font-bold mb-6">Oops! Something goes wrong.</p> 
            </Fade>
          <Fade delay={300}>
            <h1 className="text-white text-5xl md:text-huge-md xl:text-huge md:ml-16">404</h1> 
            </Fade>
          <Fade delay={600}>
            <h3 className="text-white text-5xl md:ml-16">Page not found</h3>
          </Fade>

          <Link className="md:ml-16 mt-8 text-center visitbtn inline-block py-4 px-12 border border-white text-white text-xl no-underline font-heading font-semibold" to='/'><span>Home page</span></Link>

        </div>

       

      </div>

      <BrowserView>
        <div className="video-container">
          <video autoPlay loop muted>
            <source src={videoMP4} type="video/mp4" />
            <source src={videoWEBm} type="video/webm" />
          </video>
        </div>
      </BrowserView>
      <MobileView>
        <div className="video-container bg-cover bg-center" style={{backgroundImage: "url(" + bg + ")"}}>
        </div>
      </MobileView>

      </div>
    );
  }
}

export default Notfound;





// WEBPACK FOOTER //
// ./src/pages/Notfound.js